import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { Http } from '@angular/http';

@Injectable()
export class TutorialService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  getItemById(id: number){
    return this.http.get("/api/tutorials/"+id).map(res => res.json());
  }

  getAllTutorials(){
    return this.http.get("/api/tutorials/").map(res => res.json());
  }

  create(tutorial: any) {
    return this.authHttp.post("/api/tutorials", tutorial).map(res => res.json());
  }

  update(tutorial: any){
    return this.authHttp.put("/api/tutorials", tutorial).map(res => res.json());
  }

  delete(id: number){
    return this.authHttp.delete("/api/tutorials/"+id).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/tutorial.service.ts